enum TRACKING_EVENTS {
    CLICKED = "clicou",
    SELECTED = "selecionou",
    OPEN = "abriu",
    SHOW = "exibiu",
    FILLED = "preencheu",
    PAGEVIEW = "PAGEVIEW",
}

enum TRACKING_COMPONENTS {
    CONTINUE_BUTTON = "botao:continuar",
    CONTINUE_BUTTON_FREE = "botao:continuar-com-gratuito",
    CONFIRM_NAME_BUTTON = "botao:confirmar",
    REFUSE_BUTTON = "botao:nao-obrigado",
    CONFIRM_BUTTON = "botao:entendi",
    BUTTON_KNOW_MORE = "botao:saiba-mais",
    BUTTON_SEE_MORE = "botao:veja-mais",
    TIRA_FOTO = "botao:tirar-foto",
    VOLTAR_ERRO = "botao:voltar-erro",
    CONFIRMAR_BUTTON = "botao:confirmar-nome",
    ACCEPT_BUTTON = "botao:contratar",
    ACCEPT_CARD_BUTTON = "botao:contratar-scp-",
    TYPE_CODE_KIT_CARD_BUTTON = "botao:digitar-codigo",
    ACCEPT_LIMIT_BUTTON = "botao:contratar-limite-em-conta",
    ACCEPT_BONUS_BUTTON = "botao:aceito",
    ACCEPT_SCP_BUTTON = "botao:contratar-scp",
    CLOSE_BUTTON = "botao:fechar",
    CLOSE_OVERDRAFT_MODAL_BUTTON = "botao:fechar-limite",
    ALLOW_CAMERA_ACCESS_BUTTON = "botao:permitir-acesso",
    NOT_MY_NUMBER_BUTTON = "botao:nao-e-meu-numero",
    DONT_KNOW_MY_ZIPCODE_BUTTON = "botao:nao-sei-meu-cep",
    CHANGE_CLIENT_NAME_BUTTON = "botao:mudar-nome",
    CHANGE_CLIENT_NAME = "botao:alterar-nome",
    CPF_INPUT = "input:cpf",
    MAIL_INPUT = "input:email",
    CELLPHONE_INPUT = "input:telefone",
    ZIPCODE_INPUT = "input:cep",
    ADDRESS_INPUT = "input:endereco",
    ADDRESS_NUMBER_INPUT = "input:numero",
    ADDRESS_NO_NUMBER_INPUT = "botao:sem-numero",
    ADDRESS_COMPLEMENT_INPUT = "input:complemento",
    ADDRESS_NEIGHBORHOOD_INPUT = "input:bairro",
    ADDRESS_CITY_INPUT = "input:cidade",
    ADDRESS_STATE_INPUT = "input:estado",
    SELECTED_ADDRESS = "botao:encontrar-cep:enderecos-encontrados",
    SEARCH_ZIPCODE = "botao:buscar-cep",
    NOT_FOREIGN = "botao:cidadania",
    REDIRECT_APP = "botao:acesse-o-app-santander",
    ACADEMIC = "botao:universitario-",
    I_WANT_THIS = "botao:quero-esse:",
    I_WANT = "botao:eu-quero",
    MORE_DETAILS = "botao:mais-detalhes",
    I_WANT_DETAILS = "botao:eu-quero-detalhes",
    OTHERS_OPTIONS = "botao:outras-opcoes",
    GET_EXPRESS_CARD = "card:pegue-cartao-com-gerente",
    AGENCY_RADIO = "radio:receber-agencia",
    HOME_RADIO = "radio:receber-meu-endereco",
    CODE_LINK = "link:digitar-codigo",
    USER_AUTHORIZE = "botao:eu-autorizado",
    LINK_KNOW_MORE = "link:saiba-mais",
    FREQUENT_DOUBTS = "link:acesse-duvidas-frequentes",
    CONTINUE_OFFER_FREE = "link:continuar-com-gratuito",
    BUTTON_DETAILS = "BUTTON_DETAILS",
}

enum PAGE_VIEWS_CARD {
    "identificacao" = "/pf/funil/contas/abertura-de-conta/conta-cartao/dados-pessoais/step-1b",
    "token" = "/pf/funil/contas/abertura-de-conta/conta-cartao/token",
    "status-conta-token" = "/pf/funil/contas/abertura-de-conta/conta-cartao/token-status",
    "confirmar-nome" = "/pf/funil/contas/abertura-de-conta/conta-cartao/confirmar-nome",
    "mudar-nome" = "/pf/funil/contas/abertura-de-conta/conta-cartao/mudar-nome",
    "criar-senha" = "/pf/funil/contas/abertura-de-conta/conta-cartao/senha-multicanal",
    "produtos-e-termos" = "/pf/funil/contas/abertura-de-conta/conta-cartao/produtos-e-termos",
    "feedback-envio" = "/pf/funil/contas/abertura-de-conta/conta-cartao/abertura-de-conta-em-analise/envio/com-senha",
    "feedback-envio-sem-senha" = "/pf/funil/contas/abertura-de-conta/conta-cartao/abertura-de-conta-em-analise/envio/sem-senha",
    "feedback-check-sem-senha" = "/pf/funil/contas/abertura-de-conta/conta-cartao/abertura-de-conta-em-analise/checagem/sem-senha",
    "feedback-check" = "/pf/funil/contas/abertura-de-conta/conta-cartao/abertura-de-conta-em-analise/checagem/com-senha",
    "inativo" = "/pf/funil/contas/abertura-de-conta/conta-cartao/abertura-de-conta-em-analise/inativo",
    "erro" = "/pf/erro/conta-corrente/conta-cartao/erro-generico",
    "ja-possui-conta" = "/pf/erro/conta-corrente/conta-cartao/perfil-existente",
    "conta-indisponivel" = "/pf/funil/contas/abertura-de-conta/conta-cartao/reset-proposta/cpf-bloqueado",
    "erro-de-servico" = "/pf/erro/conta-corrente/conta-cartao/erro-de-servico",
    "erro-sem-conexao" = "/pf/erro/conta-corrente/conta-cartao/sem-conexao",
    "faq" = "/pf/funil/contas/abertura-de-conta/conta-cartao/perguntas-frequentes",
    "status-conta-email" = "/pf/funil/contas/abertura-de-conta/conta-cartao/status-conta-email",
    "landing" = "/pf/funil/contas/abertura-de-conta/conta-cartao/vantagens-em-ter-uma-conta-corrente-no-santander",
    "dados-pessoais" = "/pf/funil/contas/abertura-de-conta/conta-cartao/completar-cadastro/step-3a",
    "endereco" = "/pf/funil/contas/abertura-de-conta/conta-cartao/endereco/step-3b",
    "biometria" = "/pf/funil/contas/abertura-de-conta/conta-cartao/biometria",
    "tirar-foto" = "/pf/funil/contas/abertura-de-conta/conta-cartao/biometria/tirar-foto",
    "selfies" = "/pf/funil/contas/abertura-de-conta/conta-cartao/envio-de-fotos/step-3c",
    "confirmacao" = "/pf/funil/contas/abertura-de-conta/conta-cartao/detalhes-da-contratacao/step-5",
    "capturar-selfie" = "/pf/funil/contas/abertura-de-conta/conta-cartao/capturar-selfie",
    "envio-de-doc" = "/pf/funil/contas/abertura-de-conta/conta-cartao/envio-de-documentos",
    "ver-documento" = "/pf/funil/contas/abertura-de-conta/conta-cartao/ver-documento",
    "cartao" = "/pf/funil/contas/abertura-de-conta/conta-cartao/ofertas-de-cartao",
    "seguro-cartao" = "/pf/funil/contas/abertura-de-conta/conta-cartao/seguro-cartao",
    "capturar-doc" = "/pf/funil/contas/abertura-de-conta/conta-cartao/capturar-documentos",
    "limite-em-conta" = "/pf/funil/contas/abertura-de-conta/conta-cartao/limite-em-conta",
    "proposta-aprovada" = "/pf/funil/contas/abertura-de-conta/conta-cartao/solicitacao-aprovada",
    "data-vencimento-fatura" = "/pf/funil/contas/abertura-de-conta/conta-cartao/data-de-vencimento-da-fatura/step-4d",
    "aprovado" = "/pf/funil/contas/abertura-de-conta/conta-cartao/aprovado",
    "adormecido" = "/pf/funil/contas/abertura-de-conta/conta-cartao/adormecido",
    "negado" = "/pf/funil/contas/abertura-de-conta/conta-cartao/negado",
    "aviso-correntista" = "/pf/erro/abertura-de-conta/conta-cartao/perfil-existente",
}

enum PAGE_VIEWS_UNIFIED {
    "identificacao" = "/pf/funil/contas/abertura-de-conta/unificada/dados-pessoais/step-1b",
    "token" = "/pf/funil/contas/abertura-de-conta/unificada/token",
    "status-conta-token" = "/pf/funil/contas/abertura-de-conta/unificada/token-status",
    "confirmar-nome" = "/pf/funil/contas/abertura-de-conta/unificada/confirmar-nome",
    "mudar-nome" = "/pf/funil/contas/abertura-de-conta/unificada/mudar-nome",
    "criar-senha" = "/pf/funil/contas/abertura-de-conta/unificada/senha-multicanal",
    "produtos-e-termos" = "/pf/funil/contas/abertura-de-conta/unificada/produtos-e-termos",
    "feedback-envio" = "/pf/funil/contas/abertura-de-conta/unificada/abertura-de-conta-em-analise/envio/com-senha",
    "feedback-envio-sem-senha" = "/pf/funil/contas/abertura-de-conta/unificada/abertura-de-conta-em-analise/envio/sem-senha",
    "feedback-check-sem-senha" = "/pf/funil/contas/abertura-de-conta/unificada/abertura-de-conta-em-analise/checagem/sem-senha",
    "feedback-check" = "/pf/funil/contas/abertura-de-conta/unificada/abertura-de-conta-em-analise/checagem/com-senha",
    "inativo" = "/pf/funil/contas/abertura-de-conta/unificada/abertura-de-conta-em-analise/inativo",
    "erro" = "/pf/erro/conta-corrente/unificada/erro-generico",
    "aviso-correntista" = "/pf/erro/conta-corrente/unificada/perfil-existente",
    "conta-indisponivel" = "/pf/funil/contas/abertura-de-conta/unificada/reset-proposta/cpf-bloqueado",
    "erro-de-servico" = "/pf/erro/conta-corrente/unificada/erro-de-servico",
    "erro-sem-conexao" = "/pf/erro/conta-corrente/unificada/sem-conexao",
    "faq" = "/pf/funil/contas/abertura-de-conta/unificada/perguntas-frequentes",
    "status-conta-email" = "/pf/funil/contas/abertura-de-conta/unificada/status-conta-email",
    "landing" = "/pf/funil/contas/abertura-de-conta/unificada/vantagens-em-ter-uma-conta-corrente-no-santander",
    "dados-pessoais" = "/pf/funil/contas/abertura-de-conta/unificada/completar-cadastro/step-3a",
    "endereco" = "/pf/funil/contas/abertura-de-conta/unificada/endereco/step-3b",
    "biometria" = "/pf/funil/contas/abertura-de-conta/unificada/biometria",
    "tirar-foto" = "/pf/funil/contas/abertura-de-conta/unificada/biometria/tirar-foto",
    "selfies" = "/pf/funil/contas/abertura-de-conta/unificada/envio-de-fotos/step-3c",
    "confirmacao" = "/pf/funil/contas/abertura-de-conta/unificada/detalhes-da-contratacao/step-5",
    "capturar-selfie" = "/pf/funil/contas/abertura-de-conta/unificada/capturar-selfie",
    "envio-de-doc" = "/pf/funil/contas/abertura-de-conta/unificada/envio-de-documentos",
    "ver-documento" = "/pf/funil/contas/abertura-de-conta/unificada/ver-documento",
    "cartao" = "/pf/funil/contas/abertura-de-conta/unificada/ofertas-de-cartao",
    "oferta-de-cartao-unificado" = "/pf/funil/contas/abertura-de-conta/unificada/ofertas-de-cartao",
    "oferta" = "/pf/funil/contas/abertura-de-conta/unificada/ofertas-de-conta/step-2",
    // 'oferta-gratuita' = '/pf/funil/contas/abertura-de-conta/unificada/ofertas-de-conta/conta-gratuita',

    "seguro-cartao" = "/pf/funil/contas/abertura-de-conta/unificada/seguro-cartao",
    "capturar-doc" = "/pf/funil/contas/abertura-de-conta/unificada/capturar-documentos",
    "limite-em-conta" = "/pf/funil/contas/abertura-de-conta/unificada/limite-em-conta",
    "proposta-aprovada" = "/pf/funil/contas/abertura-de-conta/unificada/solicitacao-aprovada",
    "data-vencimento-fatura" = "/pf/funil/contas/abertura-de-conta/unificada/data-de-vencimento-da-fatura/step-4d",
    "aprovado" = "/pf/funil/contas/abertura-de-conta/unificada/conta-cartao/aprovado",
    "adormecido" = "/pf/funil/contas/abertura-de-conta/unificada/conta-cartao/adormecido",
    "negado" = "/pf/funil/contas/abertura-de-conta/unificada/conta-cartao/negado",

    "openfinance" = "/pf/funil/contas/abertura-de-conta/unificada/open-finance",

    "bonus-celular" = "/pf/funil/contas/abertura-de-conta/unificada/bonus-no-celular/step-4e",

    "express-cartao-sem-credito" = "/pf/funil/contas/abertura-de-conta/unificada/ofertas-cartao-expresso/sem-credito",
    "express-QRCode-sem-credito" = "/pf/funil/contas/abertura-de-conta/unificada/ofertas-cartao-expresso/qr-code/sem-credito",
    "express-QRCode-invalido-sem-credito" = "/pf/funil/contas/abertura-de-conta/unificada/ofertas-cartao-expresso/qr-code-invalido/sem-credito",
    "express-camera-negada-sem-credito" = "/pf/funil/contas/abertura-de-conta/unificada/ofertas-cartao-expresso/acesso-camera-negado/sem-credito",
    "express-cadastro-sem-credito" = "/pf/funil/contas/abertura-de-conta/unificada/ofertas-cartao-expresso/cartao-cadastrado/sem-credito",
    "express-validacao-sem-credito" = "/pf/funil/contas/abertura-de-conta/unificada/ofertas-de-cartao-expresso/validacao/sem-credito",

    "express-cartao-com-credito" = "/pf/funil/contas/abertura-de-conta/unificada/ofertas-de-cartao-expresso/com-credito",
    "express-QRCode-com-credito" = "/pf/funil/contas/abertura-de-conta/unificada/ofertas-cartao-expresso/qr-code/com-credito",
    "express-QRCode-invalido-com-credito" = "/pf/funil/contas/abertura-de-conta/unificada/ofertas-cartao-expresso/qr-code-invalido/com-credito",
    "express-camera-negada-com-credito" = "/pf/funil/contas/abertura-de-conta/unificada/ofertas-cartao-expresso/acesso-camera-negado/com-credito",
    "express-cadastro-com-credito" = "/pf/funil/contas/abertura-de-conta/unificada/ofertas-cartao-expresso/cartao-cadastrado/com-credito",
    "express-validacao-com-credito" = "/pf/funil/contas/abertura-de-conta/unificada/ofertas-de-cartao-expresso/validacao/com-credito",
}

enum PAGE_VIEWS {
    "identificacao" = "/pf/funil/contas/abertura-de-conta/simplificada/dados-pessoais/step-1b",
    "token" = "/pf/funil/contas/abertura-de-conta/simplificada/token",
    "status-conta-token" = "/pf/funil/contas/abertura-de-conta/simplificada/token-status",
    "confirmar-nome" = "/pf/funil/contas/abertura-de-conta/simplificada/confirmar-nome",
    "mudar-nome" = "/pf/funil/contas/abertura-de-conta/simplificada/mudar-nome",
    "criar-senha" = "/pf/funil/contas/abertura-de-conta/simplificada/senha-multicanal",
    "produtos-e-termos" = "/pf/funil/contas/abertura-de-conta/simplificada/produtos-e-termos",
    "feedback-envio" = "/pf/funil/contas/abertura-de-conta/simplificada/abertura-de-conta-em-analise/envio/com-senha",
    "feedback-envio-sem-senha" = "/pf/funil/contas/abertura-de-conta/simplificada/abertura-de-conta-em-analise/envio/sem-senha",
    "feedback-check-sem-senha" = "/pf/funil/contas/abertura-de-conta/simplificada/abertura-de-conta-em-analise/checagem/sem-senha",
    "feedback-check" = "/pf/funil/contas/abertura-de-conta/simplificada/abertura-de-conta-em-analise/checagem/com-senha",
    "inativo" = "/pf/funil/contas/abertura-de-conta/simplificada/abertura-de-conta-em-analise/inativo",
    "feedback-inativo" = "/pf/funil/contas/abertura-de-conta/simplificada/abertura-de-conta-em-analise/checagem/inativo",
    "erro" = "/pf/erro/conta-corrente/simplificada/erro-generico",
    "ja-possui-conta" = "/pf/erro/conta-corrente/simplificada/perfil-existente",
    "conta-indisponivel" = "/pf/funil/contas/abertura-de-conta/simplificada/reset-proposta/cpf-bloqueado",
    "erro-de-servico" = "/pf/erro/conta-corrente/simplificada/erro-de-servico",
    "erro-sem-conexao" = "/pf/erro/conta-corrente/simplificada/sem-conexao",
    "faq" = "/pf/funil/contas/abertura-de-conta/simplificada/perguntas-frequentes",
    "status-conta-email" = "/pf/funil/contas/abertura-de-conta/simplificada/status-conta-email",
    "landing" = "/pf/funil/contas/abertura-de-conta/simplificada/vantagens-em-ter-uma-conta-corrente-no-santander",
    "dados-pessoais" = "/pf/funil/contas/abertura-de-conta/simplificada/completar-cadastro/step-3a",
    "endereco" = "/pf/funil/contas/abertura-de-conta/simplificada/endereco/step-3b",
    "biometria" = "/pf/funil/contas/abertura-de-conta/simplificada/biometria",
    "tirar-foto" = "/pf/funil/contas/abertura-de-conta/simplificada/biometria/tirar-foto",
    "selfies" = "/pf/funil/contas/abertura-de-conta/simplificada/envio-de-fotos/step-3c",
    "confirmacao" = "/pf/funil/contas/abertura-de-conta/simplificada/detalhes-da-contratacao/step-5",
    "capturar-selfie" = "/pf/funil/contas/abertura-de-conta/simplificada/capturar-selfie",
    "envio-de-doc" = "/pf/funil/contas/abertura-de-conta/simplificada/envio-de-documentos",
    "ver-documento" = "/pf/funil/contas/abertura-de-conta/simplificada/ver-documento",
    "oferta" = "/pf/funil/contas/abertura-de-conta/simplificada/ofertas-de-conta/step-2",
    "cartao" = "/pf/funil/contas/abertura-de-conta/simplificada/ofertas-de-cartao",
    "seguro-cartao" = "/pf/funil/contas/abertura-de-conta/simplificada/seguro-cartao",
    "capturar-doc" = "/pf/funil/contas/abertura-de-conta/simplificada/capturar-documentos",
    "limite-em-conta" = "/pf/funil/contas/abertura-de-conta/simplificada/limite-em-conta",
    "proposta-aprovada" = "/pf/funil/contas/abertura-de-conta/simplificada/solicitacao-aprovada",
    "bonus-celular" = "/pf/funil/contas/abertura-de-conta/simplificada/bonus-no-celular/step-4e",
    "aviso-correntista" = "/pf/erro/abertura-de-conta/simplificada/perfil-existente",
    "data-vencimento-fatura" = "/pf/funil/contas/abertura-de-conta/simplificada/data-de-vencimento-da-fatura/step-4d",

    "express-cartao-sem-credito" = "/pf/funil/contas/abertura-de-conta/simplificada/ofertas-cartao-expresso/sem-credito",
    "express-QRCode-sem-credito" = "/pf/funil/contas/abertura-de-conta/simplificada/ofertas-cartao-expresso/qr-code/sem-credito",
    "express-QRCode-invalido-sem-credito" = "/pf/funil/contas/abertura-de-conta/simplificada/ofertas-cartao-expresso/qr-code-invalido/sem-credito",
    "express-camera-negada-sem-credito" = "/pf/funil/contas/abertura-de-conta/simplificada/ofertas-cartao-expresso/acesso-camera-negado/sem-credito",
    "express-cadastro-sem-credito" = "/pf/funil/contas/abertura-de-conta/simplificada/ofertas-cartao-expresso/cartao-cadastrado/sem-credito",
    "express-validacao-sem-credito" = "/pf/funil/contas/abertura-de-conta/simplificada/ofertas-de-cartao-expresso/validacao/sem-credito",

    "express-cartao-com-credito" = "/pf/funil/contas/abertura-de-conta/simplificada/ofertas-de-cartao-expresso/com-credito",
    "express-QRCode-com-credito" = "/pf/funil/contas/abertura-de-conta/simplificada/ofertas-cartao-expresso/qr-code/com-credito",
    "express-QRCode-invalido-com-credito" = "/pf/funil/contas/abertura-de-conta/simplificada/ofertas-cartao-expresso/qr-code-invalido/com-credito",
    "express-camera-negada-com-credito" = "/pf/funil/contas/abertura-de-conta/simplificada/ofertas-cartao-expresso/acesso-camera-negado/com-credito",
    "express-cadastro-com-credito" = "/pf/funil/contas/abertura-de-conta/simplificada/ofertas-cartao-expresso/cartao-cadastrado/com-credito",
    "express-validacao-com-credito" = "/pf/funil/contas/abertura-de-conta/simplificada/ofertas-de-cartao-expresso/validacao/com-credito",
}

enum CLIENT_TYPE {
    "OPEN" = "link",
    "FOPA" = "folhapagamento",
}

enum EVENT_CATEGORY {
    "FOPA" = "portal:fopa",
    "OPEN" = "portal:link",
}

const FLOW_ID = {
    "1": "OPEN",
    "4": "FOPA",
};

const LIST_ERROS_CAMERA = {
    102: "Tempo de sessão esgotou.",
    103: "Tempo do smart câmera aberto sem encontrar nenhuma face durante 20 segundos.",
    104: 'Usuário está com o "Lock screen desabilitado".',
    105: "Usuário precisa estar durante a captura com o foco na aba.",
    106: "Usuário não pode desligar o visor da tela do celular durante a captura.",
    107: "Erro de implementação durante a integração",
    73707: "A sessão foi cancelada porque o aplicativo foi encerrado, colocado em suspensão.",
    73710: "A sessão foi cancelada porque o usuário não conseguiu concluir uma sessão no tempo alocado padrão ou no tempo limite definido pelo desenvolvedor.",
    73717: "A sessão foi cancelada porque o usuário estava em um estado bloqueado.",
    73718: "A sessão foi cancelada devido a um erro desconhecido e inesperado.",
    73721: "A sessão foi cancelada devido a uma alteração na orientação do dispositivo durante a sessão.",
};

enum PAGE_VIEW_WITHOUT_CREDIT {
    "CARD" = "express-cartao-sem-credito",
    "QRCODE" = "express-QRCode-sem-credito",
    "QRCODE_INVALID" = "express-QRCode-invalido-sem-credito",
    "CAM_DENIED" = "express-camera-negada-sem-credito",
    "REGISTRATION" = "express-cadastro-sem-credito",
    "VALIDATION" = "express-validacao-sem-credito",
}

enum PAGE_VIEW_WITH_CREDIT {
    "CARD" = "express-cartao-com-credito",
    "QRCODE" = "express-QRCode-com-credito",
    "QRCODE_INVALID" = "express-QRCode-invalido-com-credito",
    "CAM_DENIED" = "express-camera-negada-com-credito",
    "REGISTRATION" = "express-cadastro-com-credito",
    "VALIDATION" = "express-validacao-com-credito",
}

enum TERM_GA_ENUM {
    "eventLabelLink" = "link:expandir-termos-condicoes",
    "eventLabelShow" = "modal:termos-condicoes",
    "eventLabelCloseBottom" = "botao:concordar-finalizar:termos-condicoes",
    "eventLabelCloseTop" = "botao:fechar-superior:termos-condicoes",
}

export {
    TRACKING_COMPONENTS,
    TRACKING_EVENTS,
    PAGE_VIEWS,
    CLIENT_TYPE,
    EVENT_CATEGORY,
    PAGE_VIEWS_CARD,
    PAGE_VIEWS_UNIFIED,
    PAGE_VIEW_WITHOUT_CREDIT,
    PAGE_VIEW_WITH_CREDIT,
    FLOW_ID,
    LIST_ERROS_CAMERA,
    TERM_GA_ENUM,
};
